import { useSelector } from 'react-redux';
import ReportBugButton from './ReportBugButton';
import { AUTH_TOKEN } from '@/api/constants';
import Cookies from 'js-cookie';
import { useState, useEffect } from 'react';
import type { RootState } from '@/components/WellLoggingOperations/types';

const AuthenticatedReportBugButton = () => {
    const authFromStore = useSelector((state: RootState) => state.auth.isLoggedIn);
    const [isLoggedIn, setIsLoggedIn] = useState(authFromStore);

    useEffect(() => {
        setIsLoggedIn(authFromStore || Boolean(Cookies.get(AUTH_TOKEN)));
    }, [authFromStore]);

    if (typeof window === 'undefined') return null;

    return isLoggedIn ? <ReportBugButton /> : null;
};

export default AuthenticatedReportBugButton;
